import { createApp } from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import { loadFonts } from './plugins/webfontloader'
import router from './router'
import store from './store'
import { Amplify } from 'aws-amplify'
import VueGoogleMaps from "@fawmi/vue-google-maps";

const app = createApp(App)
.use(VueGoogleMaps, {
    load: {
      key: 'AIzaSyBGx0GVYXax5i6Bs3eCglSrUGaIAvKrgXk',
      libraries: ["places"]
    },
    autobindAllEvents: true,
  })
// Initialize store
store.dispatch('initializeStore')

// Router guard
router.beforeEach((to, from, next) => {
  const isLoggedIn = store.getters.isLoggedIn || false

  if (to.meta.requiresAuth && !isLoggedIn) {
    next('/login')
  } else if (to.path === '/login' && isLoggedIn) {
    next('/teams')
  } else {
    next()
  }
})

loadFonts()
try {
  Amplify.configure({
    Auth: {
      Cognito: {
        userPoolId: "ap-south-1_MFLSQGP6m",
        userPoolClientId: "2dg3ufeg95heeahikbkjq4kja7",
        identityPoolId: "ap-south-1:c047035c-6800-4293-9fbe-7ff083e4c864",
        signUpVerificationMethod: "code",
        loginWith: {
          email: true,
        },
      },
    },
    API: {
      GraphQL: {
        endpoint:
          "https://sslkdrqtkbhafnkgpcnfya53be.appsync-api.ap-south-1.amazonaws.com/graphql",
        region: "ap-south-1",
        defaultAuthMode: "userPool",
      },
      endpoints: [
        {
          name: "prznce_payment",
          endpoint: "https://liql60b1h9.execute-api.ap-south-1.amazonaws.com/prezence",
        },
        {
          name: "Report_issue",
          endpoint: " https://61fvl4pi50.execute-api.ap-southeast-1.amazonaws.com/dev/",
        },
      ],
    },
    Storage: {
      S3: {
        bucket: "przncemembersprofile",
        region: "ap-south-1",
      },
    },
  })
} catch (error) {
  console.error("Amplify configuration error:", error)
}
app.use(store).use(router)
  .use(vuetify)
  .mount('#app')
